import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { createProjectsColumns } from "../data-table/columns";

type ProjectsViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type ProjectsViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useProjectsViewOptions = ({
  onVisibilityChange,
}: ProjectsViewOptionsProps = {}): ProjectsViewOptionsReturn => {
  const columns = useMemo(() => createProjectsColumns(), []);

  return useTableViewOptions({
    columns,
    storageKey: "projects-table-column-visibility",
    onVisibilityChange,
    label: "Columns",
    className: "h-9 px-3 gap-2",
  });
};
